import { on } from "events";
import { FormItemType } from "../../../UI/view/component-map";
import { FilterType, initListView, ListView, ListViewColumnType } from "../../../UI/view/list-view";
import { dewarRulesDataSource } from "./dewar-datasource";
import { dewarRulesCreateForm } from "./dewar-rule-create";
import { billingPackagedProdAdminPermissions as billingPermissions } from "../billing-datasource";

export const dewarRulesList = (fromCustDetails) => ({
  permissions: {...billingPermissions, write: billingPermissions.admin},
  toolbar: [
    {
      type: FormItemType.button,
      label: 'Summary Report',
      handler: () => {
        const url = `http://${process.env.REACT_APP_RPT}/ReportServer/Pages/ReportViewer.aspx?%2fBulk+Helium+Reports%2fDewarRulesByType&rs:Command=Render`;
        window.open(url, '_blank');
      }
    }
  ],
  create: dewarRulesCreateForm('create', fromCustDetails),
  update: dewarRulesCreateForm('update', fromCustDetails),
  filters: [
    {
      type: FilterType.combo,
      label: 'Rule Type',
      fieldName: 'ruleType',
    },
    {
      type: FilterType.simple,
      label: 'Active Only',
      fieldName: 'isActive',
      filterValue: true
    }
  ],
  columns: [
    {
      type: ListViewColumnType.edit
    },
    {
      type: ListViewColumnType.delete
    },
    {
      Header: 'Customer Name',
      id: 'customerName',
      accessor: ({ customerName, cst }) => customerName?.length ? customerName : cst,
      type: ListViewColumnType.link,
      linkPath: ({ val, row }) => '/customers/edit/dewars/' + row.original.cst,
      defaultSort: true
    },
    {
      Header: 'CST',
      accessor: 'cst'
    },
    {
      Header: 'Rule Type',
      accessor: 'ruleType'
    },
    {
      Header: 'Value',
      accessor: 'value'
    },
    {
      Header: 'Date Rule Effective',
      accessor: 'effectiveDate',
      type: ListViewColumnType.date
    },
    {
      Header: 'Date Rule Expires',
      accessor: 'expiresDate',
      type: ListViewColumnType.date
    },
    {
      Header: 'User Created',
      id: 'userIdinput',
      accessor: ({ userIdinput, userNameInput }) => userNameInput?.length ? userNameInput : userIdinput
    },
    {
      accessor: 'isActive',
      hidden: true,
    },
  ]
});

export const DewarRulesList = initListView(dewarRulesList(false), dewarRulesDataSource);
export const DewarRulesListForCustomer = initListView(dewarRulesList(true), dewarRulesDataSource, (state) => {
  return state.dewarRules?.data?.filter(x => {
    return x.cst == state.dewarcustomers?.current?.data?.site;
  })
});